/* dmp 接口中间件 */
import axios from 'axios';
import qs from 'qs';
// import NProgress from 'nprogress' // dmp埋点静默发送，不显示进度条
const instance = axios.create({
  timeout: 30 * 1000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    Authorization: 'Bearer 1|rrOjXqhqJZaEzrUVi65NKOLzCheHGSVXGNl69Khr',
    Accept: 'application/json',
  },
});
instance.interceptors.request.use(
  (config) => {
    // NProgress.start()
    config._url = config.url;
    // 详情页转化埋点，传数组时，需要转成JSON格式
    if (config._url == '/product/view' && config.data.product_cart) {
      config.headers['Content-Type'] = 'application/json; charset=utf-8';
    } else {
      config.method === 'post' && (config.data = qs.stringify(config.data));
    }
    // 不再取消连续发送的请求，因为性能上报接口会有连续发送不同type值的数据情况
    // cancelPending(config.url)
    // config.cancelToken = new CancelToken(res => {
    //     pending[config.url] = res
    // })
    return config;
  },
  (error) =>
    Promise.reject({
      status: 600,
      msg: error.data.error.message,
    }),
);
instance.interceptors.response.use(
  (res) => {
    // NProgress.done()
    // delete pending[res.config._url]
    return res.data.code == 200 ? Promise.resolve(res.data) : Promise.reject(res.data);
  },
  (error) => {
    console.log(error);
    throw error;
    // NProgress.done()
  },
);
/*
 * @description axios.post
 * @param url    {String}  post url
 * @param param  {Object}  post body
 * @param config {Object}  post config
 *    @errorMsg {Boolean} 是否开启失败提示
 *    @successMsg {Boolean} 是否开启成功提示
 *    @msgType {String} 提示弹窗类型
 *    @mock {Function} mock数据
 * @return {Promise}
 * 失败状态码
 * 0~500 后端定义
 * 500   网络中断
 * 600   请求创建失败
 * 700   接口取消
 */
// const post = (url, param, config) => {
//     const runtimeConfig = useRuntimeConfig()
//     url = runtimeConfig.public.VUE_DMP_API + url
//     config = config || {}
//     config.errorMsg = config.errorMsg === undefined ? false : config.errorMsg
//     config.successMsg = config.successMsg === undefined ? false : config.successMsg
//     config.msgType = config.msgType === undefined ? 'default' : config.msgType
//     if (typeof config.mock === 'function') return Promise.resolve(config.mock())
//     return new Promise((resolve, reject) => {
//         instance.post(url, param).then(res => {
//             res && resolve(res.data)
//             // dmp 不做吐司
//         }).catch(err => {
//             reject(err)
//             // dmp 不做吐司
//         })
//     })
// }

// noop
const post = async (url, param, config) => {
  // 安全起见，返回一个空对象
  return {};
};
export default post;
